// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1RN-c","col":"styles_col__Nb1Nf","fulfillmentStatus":"styles_fulfillmentStatus__6zqvh","emailCol":"styles_emailCol__1YZPl"};